import { find } from 'lodash';
import { createContext, useContext, useState } from 'react';
import { useIdCatalogSearch } from '..';
import { useComparisonState } from './useComparisonState';

const CompareManagementContext = createContext(null);

export const CompareManagementProvider = ({ children }) => {
  const [isViewsAndLayoutsCollapsed, setIsViewsAndLayoutsCollapsed] = useState(true);
  const { selectedCatalogItems, firstSlotCatalogItem, secondSlotCatalogItem } = useIdCatalogSearch();
  const [sectionInComparisonMode, setSectionInComparisonMode] = useState({ sectionId: undefined, metadata: null });

  const { comparisonState, onToggleSubMenuItem } = useComparisonState({
    firstSlotCatalogItem,
    secondSlotCatalogItem,
  });

  const canAddMoreItemsForComparison = selectedCatalogItems.length <= 1;

  const onSetSectionInComparisonMode = (sectionId, comparisonCutId) => {
    const comparisonCut = find(comparisonState[sectionId].comparisonCuts || [], { id: comparisonCutId });

    if (comparisonCut === undefined) {
      return;
    }

    const { senderMetadata } = comparisonCut;

    setSectionInComparisonMode({ sectionId, metadata: senderMetadata });
  };

  const onCloseSectionInComparisonMode = () => setSectionInComparisonMode({ sectionId: undefined, metadata: null });

  return (
    <CompareManagementContext.Provider
      value={{
        comparisonState,
        sectionInComparisonMode,
        canAddMoreItemsForComparison,
        onToggleSubMenuItem,
        onSetSectionInComparisonMode,
        onCloseSectionInComparisonMode,
      }}>
      {children}
    </CompareManagementContext.Provider>
  );
};

export const useCompareManagement = () => useContext(CompareManagementContext);
